module.exports = __webpack_public_path__ + "static/media/poney.65b83b0f.png";